import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urls } from 'src/services/api/urls';
import * as servers from '../../../services/api/servers';
import { GeneralServicesImplService } from 'src/services/general-services-impl.service';
import { Observable } from 'rxjs';
import { ProjectConstants } from 'src/app/project-constants';

@Injectable({
  providedIn: 'root'
})
export class BillingCountryService extends GeneralServicesImplService {

  constructor(http: HttpClient) {
    super(http);
  }

  baseUrl: string = servers.apiUrl + urls.deltaVolumi;
  
  getBillingCountryInAllSettings(url: string, filters: any, offset?: any): Observable<any> {
    url = servers.apiUrl + url + this.LINKS.LIST_SERVICES_COUNTRY_IN_ALL_SETTING;
    const body =  filters;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

}
